import { TitleWrapper } from "./styled";

type PageTitleProps = {
  titulo: string,
  centralizado?: boolean,
}

function PageTitle({ titulo, centralizado }: PageTitleProps) {
  return (
  <TitleWrapper>
    <h1 id={centralizado ? "tituloCentralizado" : ""}>
      {titulo}
    </h1>
  </TitleWrapper>
  );
}

export default PageTitle;
